/**
 * patrol-apprehension-edit.js
 */

import React from 'react';
import {
  Grid,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { shouldRenderMobileLayout } from 'utils/app-context';
import { EditorIconSection } from 'components/icon-section/icon-section';
import HelpTextItem from 'components/menu-drawer/help-text-item';
import FormGridItem from 'components/menu-drawer/form-grid-item';
import HiddenInput from 'components/form-inputs/hidden-input';
import CheckboxList from 'components/form-inputs/checkbox-list';
import RadioGroup from 'components/form-inputs/radio-group';
import Checkbox from 'components/form-inputs/checkbox';
import TextField from 'components/form-inputs/text-field';
import { PatrolTypeTitle } from '../../training-utils';


export default function PatrolApprehensionEdit(props) {
  const {
    patrolRecord,
    patrolIndex,
    patrolTypes,
    drawerState,
    translation,
    options,
    formPrefix = ''
  } = props;
  const formNameBase = `${formPrefix}patrol.patrolTypes[${patrolIndex}].apprehension`;
  const typeRecord = patrolRecord?.apprehension;
  const { t } = useTranslation(translation);


  return (
    <>
      <EditorIconSection
        iconName='patrol-apprehension'
        iconMarginTop={0}
        helpProps={{
          translation,
          section: 'apprehension',
          suffix: patrolTypes.length > 1 ? ` (Scenario)` : '',
        }}
      >
        {!shouldRenderMobileLayout() &&
        <PatrolTypeTitle 
          patrolType={patrolRecord.type} 
          patrolTypes={patrolTypes} 
          step={patrolRecord.order}
        />}


        {/* id */}
        <HiddenInput 
          name={`${formNameBase}.id`}
          defaultValue={typeRecord?.id || ''}
        />


        {/* recall */}
        <HelpTextItem
          sidebarText={drawerState.sidebarText}
          title={t('apprehension.recall.helpTitle')}
          text={t('apprehension.recall.helpInfo')}
        >
          <Checkbox
            name={`${formNameBase}.isRecall`}
            label={t('apprehension.recall.label')}
            defaultValue={typeRecord?.isRecall || false}
          />
        </HelpTextItem>


        {/* dog in guard position */}
        <HelpTextItem
          sidebarText={drawerState.sidebarText}
          title={t('apprehension.guardPosition.helpTitle')}
          text={t('apprehension.guardPosition.helpInfo')}
        >
          <Checkbox
            name={`${formNameBase}.isDogInGuardPosition`}
            label={t('apprehension.guardPosition.label')}
            defaultValue={typeRecord?.isDogInGuardPosition || false}
          />
        </HelpTextItem>


        {/* decoy / quarry name */}
        <HelpTextItem
          sidebarText={drawerState.sidebarText}
          title={t('apprehension.decoyName.helpTitle')}
          text={t('apprehension.decoyName.helpInfo')}
        >
          {focusHandlers =>
            <Grid container spacing={2}>
              <FormGridItem>
                <TextField
                  name={`${formNameBase}.decoyName`}
                  label={t('apprehension.decoyName.label')}
                  focusHandlers={focusHandlers}
                  defaultValue={typeRecord?.decoyName || ''}
                  rules={{
                    maxLength: {
                      value: 250,
                      message: t('apprehension.decoyName.errMsgLength')
                    }
                  }}
                />
              </FormGridItem>
            </Grid>}
        </HelpTextItem>

        
        {/* equipment used */}
        <HelpTextItem
          sidebarText={drawerState.sidebarText}
          title={t('apprehension.equipment.helpTitle')}
          text={t('apprehension.equipment.helpInfo')}
        >
          {focusHandlers =>
            <CheckboxList
              name={`${formNameBase}.equipmentTypes`}
              label={t('apprehension.equipment.label')}
              options={options.apprehensionEquipmentTypes}
              focusHandlers={focusHandlers}
              defaultValue={typeRecord?.equipmentTypes}
              customOther
              rules={{
                validate: val => (val && val.length > 0) || t('apprehension.equipment.errMsgEmpty')
              }}
            />}
        </HelpTextItem>


        {/* bite-release */}
        <HelpTextItem
          sidebarText={drawerState.sidebarText}
          title={t('apprehension.biteRelease.helpTitle')}
          text={t('apprehension.biteRelease.helpInfo')}
          style={{ marginTop: 16 }}
        >
          {focusHandlers =>
            <RadioGroup
              name={`${formNameBase}.biteRelease`}
              label={t('apprehension.biteRelease.label')}
              options={options.apprehensionBiteReleaseTypes}
              setValueAs={value => ({ id: parseInt(value) })}
              focusHandlers={focusHandlers}
              defaultValue={typeRecord?.biteRelease}
              rules={{
                required: t('apprehension.biteRelease.errMsgEmpty')
              }}
            />}
        </HelpTextItem>

      </EditorIconSection>
    </>
  );
}